import { Link } from "react-router";

import { CategoryCard } from "@/features/shop";
import { cn } from "@/shared/utils/style.util";
import type { LucideIcon } from "lucide-react";

export type CategoryGridCardProps = {
  icon: LucideIcon
  title: string
  backgroundColor: string
  textColor: string
  link: string
};

export const CategoryGridCard = ({
  icon: IconComponent,
  title,
  backgroundColor,
  textColor,
  link,
}: CategoryGridCardProps) => {
  return (
    <Link to={link} className="block h-full" title={title}>
      <CategoryCard
        className={cn(
          backgroundColor,
          "group cursor-pointer rounded-xl",
          "transition-all duration-200",
          "hover:scale-[1.04] hover:brightness-110 hover:shadow-md",
          "relative overflow-visible",
        )}
      >
        <div
          className={cn(
            "flex h-full items-center",
            "justify-center px-0 py-3",
            "sm:justify-start sm:gap-2 sm:px-3 sm:py-5",
            "lg:gap-2.5 lg:px-4",
          )}
        >
          <div
            className={cn(
              "flex flex-shrink-0 items-center justify-center rounded-xl",
              backgroundColor,
              textColor,
              "h-8 w-8 sm:h-9 sm:w-9",
            )}
          >
            <IconComponent
              strokeWidth={2}
              className="h-4 w-4 sm:h-5 sm:w-5"
            />
          </div>

          <span
            className={cn(
              "hidden sm:line-clamp-2",
              "min-w-0 font-semibold leading-tight",
              textColor,
              "sm:text-xs md:text-sm lg:text-base",
            )}
          >
            {title}
          </span>
        </div>

        <span
          className={cn(
            "absolute left-1/2 -translate-x-1/2 -bottom-8",
            "px-2 py-1 rounded text-xs font-medium whitespace-nowrap",
            "bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900",
            "opacity-0 group-hover:opacity-100 pointer-events-none",
            "transition-opacity duration-200",
            "z-50",
            "sm:hidden",
          )}
        >
          {title}
        </span>
      </CategoryCard>
    </Link>
  );
};
